import { useState, useEffect } from "react"
import { useWeb3React } from "@web3-react/core"

import getBlockchainConfig, {
	fallbackChain,
	fallbackChainId,
	targetChain as initialTargetChain,
	targetChainId as initialTargetChainId,
} from "../config/web3/getBlockchainConfig"

import { Notification } from "../components/HonestNotification"
import wait from "../utils/wait"

const chainConfig = getBlockchainConfig()

const notificationTimeoutMs = 2000

const useHonestChainWatchtower = () => {
	const {
		chainId,
		active,
		activate,
		deactivate,
		account: address,
		library,
		connector,
	} = useWeb3React()

	const [showNotification, setShowNotification] = useState(null)
	const [signer, setSigner] = useState(null)
	const [targetChain, _setTargetChain] = useState(initialTargetChain)
	const [targetChainId, _setTargetChainId] = useState(initialTargetChainId)
	const [notification, setNotification] = useState<Notification>({
		message: "",
		variant: null,
	})

	const toggleShowNotification = () => {
		setShowNotification(!showNotification)
	}

	useEffect(() => {
		const bootWatchTower = async () => {
			if (!active && !!library) {
				try {
					await activate(connector)

					setSigner(library.getSigner())

					console.info(`Connected to ${chainId}`)
					setNotification({
						message: `Connected to ${chainId}`,
						variant: "success",
					})

					toggleShowNotification()
					await wait(notificationTimeoutMs)
					toggleShowNotification()
				} catch (error) {
					console.error(error)
					setNotification({
						message: `Could not connect to ${targetChain} ${targetChainId}`,
						variant: "error",
					})
					toggleShowNotification()
					await wait(notificationTimeoutMs)
					toggleShowNotification()
				} finally {
					console.info("HonestWatchTower is ready")
				}
			}
		}

		bootWatchTower()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [active, connector, chainId, targetChain, targetChainId])

	return {
		notification,
		showNotification,

		// User
		active,
		address,
		signer,

		// Network
		chainId,
		chainConfig,
		targetChain,
	}
}

export default useHonestChainWatchtower
